import React, { forwardRef, memo, ReactNode } from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import { ICollapsibleBlockProps } from './CollapsibleBlock.types';

import './CollapsibleBlock.scss';

const CollapsibleBlock = forwardRef(({
	children,
	classNames,
	collapsibleBlockClassname,
	containerClassname,
	handleLabelClick,
	isClickableRow = true,
	isDisabled,
	isOpen = false,
	isLeftSideButton = false,
	label,
	name,
	toggleState = (_name?: string) => null,
	withSeparatorLine = false,
}: ICollapsibleBlockProps, ref: React.ForwardedRef<HTMLDivElement>) => {
	const className = cn({
		[`${classNames ? classNames : ''}`]: classNames,
		'f5gCollapsibleBlockWithSeparatorLine': withSeparatorLine,
	});

	const handleClick = (e: React.SyntheticEvent) => {
		e.stopPropagation();

		if (isDisabled) return;

		toggleState(name);
	};

	const onLabelClick = (e: React.SyntheticEvent) => {
		e.stopPropagation();

		if (isClickableRow || isDisabled) return;
		if (handleLabelClick) handleLabelClick(name);
	};

	return (
		<div
			ref={ref}
			className={className}
		>
			<div
				className={cn('f5gCollapsibleBlockContainer', containerClassname, {
					'disabled': isDisabled,
					'f5gLeftSideButton': isLeftSideButton,
				})}
				data-testid={`collapsible-block-${name}`}
				{...isClickableRow ? { onClick: handleClick } : {}}
			>
				<div
					className='f5gCollapsibleBlockLabel'
					onClick={onLabelClick}
				>
					{label as ReactNode}
				</div>
				<div
					className={cn('f5gCollapsibleBlockControlIcon', {
						'f5gCollapsibleBlockIsOpenIcon': isOpen,
					})}
					{...isClickableRow ? {} : { onClick: handleClick }}
					data-testid={`chevron-down-${name}`}
				>
					{Icons.chevronDown()}
				</div>
			</div>
			<div className={cn('f5gCollapsibleBlock', collapsibleBlockClassname, {
				'f5gCollapsibleBlockIsOpen': isOpen,
			})}>
				{children as ReactNode}
			</div>
		</div>
	);
});

CollapsibleBlock.displayName = 'CollapsibleBlock';

export default memo(CollapsibleBlock);
